/**
 * @generated SignedSource<<50fd165c67df32b603f1593eaa252948>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RoomPropertiesListRow_roomProperty$data = {
  readonly etgKey: string | null;
  readonly icon: string | null;
  readonly id: string;
  readonly name: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"EntityTableRow_entity">;
  readonly " $fragmentType": "RoomPropertiesListRow_roomProperty";
};
export type RoomPropertiesListRow_roomProperty$key = {
  readonly " $data"?: RoomPropertiesListRow_roomProperty$data;
  readonly " $fragmentSpreads": FragmentRefs<"RoomPropertiesListRow_roomProperty">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RoomPropertiesListRow_roomProperty",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "icon",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "etgKey",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EntityTableRow_entity"
    }
  ],
  "type": "RoomProperty",
  "abstractKey": null
};

(node as any).hash = "94f85ce37dafe910c3cee8f37d15a5b5";

export default node;
